module.exports = __webpack_public_path__ + "static/media/favicon.fe6036ef.ico";